/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-01 14:39:33
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-21 14:17:07
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Collapse/SectionCollapse.tsx
 */
import React from 'react';
import classnames from 'classnames';

import Collapse from './index';

import styles from './style.module.less';

const SectionCollapse = (props) => {
  const { titleContainerClassName, ...rest } = props;

  return (
    <Collapse
      titleContainerClassName={`${classnames(styles.sectionTitleContainer)} ${
        titleContainerClassName || ''
      }`}
      {...rest}
    />
  );
};
export default SectionCollapse;
